import { gql } from '@apollo/client';

export const VIDEO_RECOMMENDATION_QUERY = gql`
  query ($id: Int, $videoType: [String]) {
    recommendedData: recommendation(
      request: { custom: { videoType: $videoType }, perPage: 1, exclude: [$id] }
    ) {
      id
      title
      date
      link
      author {
        id
        name
        link
      }
      tags {
        name
      }
      postCategory
      videoType
      propertyType
      featuredImage {
        url
      }
      project {
        id
        name
        propertyType
        developer
        location {
          zone {
            label
            value
            link
            parent {
              value
              label
              link
            }
          }
          district {
            label
            value
            link
            parent {
              value
              label
              link
            }
          }
          road {
            label
            value
            link
            parent {
              value
              label
              link
            }
          }
        }
        transportations {
          value
          label
          link
        }
        priceTypes {
          starting_price
          level {
            value
            label
          }
        }
      }
    }
  }
`;
